<app-bar [queGame]="'Chess'"></app-bar>


<!--  <div class=" alert alerta-gameChess alert-warning alert-dismissible fade show" role="alert" >
  <a class="navbar-brand" routerLink="/" data-toggle="modal"><img src="/assets/inicio/log-white.png" height="70"/></a>


</div>  -->




<!--<div class="menu" id="difficulty">
  <br>
  <h1>Select Difficulty:</h1>
  <hr><br>
  <button type="button" (click)="setDepth(0)" class="btn easy btn-success btn-xlarge">Easy</button>
  <br><br>
  <button type="button" (click)="setDepth(1)"class="btn medium btn-warning btn-xlarge">Medium</button>
  <br><br>
  <button type="button" (click)="setDepth(2)" class="btn hard btn-danger btn-xlarge">Hard</button>
</div>-->

<div id="chessboard" role="main"style="margin:50px auto; max-width: 600px;"></div>


<!--<div id="restart" class="restartGame">
  <button type="button" class="btn medium btn-danger btn-xlarge">Restart</button>
</div>-->



<div class="modal fade" id="hacke" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Checkmate !</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" style="color:#dddddd;">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Checkmate ! the game is over
      </div>
      <div class="modal-footer">
        <button type="button" class="btn enviarc" routerLink="/"  data-dismiss="modal">Exit</button>

      </div>
    </div>
  </div>
</div>


